import * as yup from '@if/core/yup'
import type { InferType } from '@if/core/yup'

export const newTicketSchema = yup.object({
  title: yup.string().required('validation.required').trim().min(1, 'validation.required').default(''),
  description: yup
    .string()
    .default('')
    .transform((value) => (value as string) || ''),
  severity: yup.string().required('validation.required').default(''),
  plateforme: yup.string().required('validation.required').default(''),
})

export type NewTicketFormData = InferType<typeof newTicketSchema>
